const routes = [
  {
    path: '/',
    component: 'pages/Home',
  },
  {
    path: '/terms',
    component: 'pages/Terms',
  },
  {
    path: '/policy',
    component: 'pages/PrivacyPolicy',
  },
  {
    path: '/thankyou',
    component: 'pages/ThankYou',
  },
];

module.exports = routes;



// WEBPACK FOOTER //
// ./src/routes.js